export default "__VITE_ASSET__BbNx_KXf__"